import Vue from 'vue';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import i18n from "./i18n-setup";

Vue.use(BootstrapVue);
Vue.config.productionTip = false;

// 401: the session has ended (frankenphp/Caddyfile). Reloading sends the browser to the login page, which brings it
// back here after signing in.
axios.interceptors.response.use(undefined, (error) => {
  if (error.response && error.response.status === 401) {
    window.location.reload();
  }
  return Promise.reject(error);
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
